import { RedactedTaxIdentifierSchema } from "@redotech/redo-fulfillment-customs-common/customs";
import * as z from "zod";

export const deleteTaxIdentifiers = {
  name: "deleteTaxIdentifiers" as const,
  input: z.object({ identifierIds: z.array(z.string()) }),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
